import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
const Swal2 = withReactContent(Swal)

const MERCADONI_COLOR = '#42d59e'
const RED_COLOR = 'red'

const showAlert = (text, type) => {
  let alertColor = MERCADONI_COLOR
  if (type === 'error') {
    alertColor = RED_COLOR
  }
  Swal2.fire({
    html: `<p style="color:${alertColor}">${text}</p>`,
    confirmButtonColor: MERCADONI_COLOR,
    showConfirmButton: true
  })
}

const showAlertWithoutButton = (text, color = MERCADONI_COLOR) => {
  Swal2.fire({
    title: `<p style="color:${color}">${text}</p>`,
    showConfirmButton: false,
    timer: 1500
  })
}

const showAlertWithColor = (text, color) => {
  const msg = `<p style="color:${color}">${text}</p>`
  Swal2.fire({
    html: msg,
    confirmButtonColor: MERCADONI_COLOR,
    showConfirmButton: true
  })
}

const alertQuestion = async (question) => {
  const choice = await Swal2.fire({
    title: `<p class='swal2-p' >${question}</p>`,
    showConfirmButton: true,
    confirmButtonText: 'Yes',
    confirmButtonColor: RED_COLOR,
    showCancelButton: true,
    cancelButtonText: 'No'
  })
  return choice.value
}

export { showAlert, alertQuestion, showAlertWithColor, showAlertWithoutButton }
